import{requestGet, requestPost}from './reqUtils'

export const login = (data) => {
  return requestPost('/v1/user/login',data)
}
export const changePassword = (data) => {
  return requestPost('/v1/admin/user/password/set',data)
}
// 获取用户信息
export const getInfo = (token) => {
  return requestGet('/v1/user/getMenu',{token})
}
// 获取用户的按钮权限
export const getAction = (data) => requestGet('/v1/user/getAction',data)

// 获取oss Key等信息
export const getOssSTSToken  = (data) => requestGet('/v1/alists',data)
// 系统通用的审核接口
export const publicAudit = (data) => requestPost('/v1/audit',data)
// 系统通用获取负责人、员工
export const getStaff = (data) => requestGet('/v1/staff/get',data)
// 按角色获取员工
export const getStaffByRole = (data) => requestGet('/v1/user/staff/role/get', data)
// 系统通用获取流程
export const reqFlow = (data) => requestGet('/v1/flow/get',data)
/**
 * 通用导出接口
 * @param {*} data 
 * @returns 
 */
export const exportFile = (data) => requestPost('/v1/file/export',data)
/**
 * 导出记录
 * @param {*} data 
 * @returns 
 */
export const exportLog = (data) => requestGet('/v1/file/export/list',data)
/**
 * 导入记录
 * @param {*} data 
 * @returns 
 */
export const importLog = (data) => requestGet('/v1/file/import/list',data)
